import {
    MultipleServiceFilterParameters,
    ServiceResult,
    useRepositorySuspenseQuery,
} from '@mews-commander/data-access';

interface UseServicesGetAllSuspenseQuery<T> {
    select?: (data: ServiceResult) => T;
    enabled?: boolean;
}

export const useServicesGetAllSuspenseQuery = <T>(
    params: MultipleServiceFilterParameters,
    options: UseServicesGetAllSuspenseQuery<T> = {}
) => useRepositorySuspenseQuery('services', 'getAll', params, options);
